import { useMemo } from 'react'
import Image from 'next/image'

/* blocks */
import Link from '@/atoms/Link/Link'
import CarouselAlt from '@/cmp/organism/Carousel/CarouselAlt'

/* utils */
import { IndividualEventsPageAttributes } from '@/utils/queries/events-page'

/* assets */
import { ReactComponent as ArrowRight } from 'public/assets/icons/chevron-right.svg'

interface Props {
  title: string
  lists: IndividualEventsPageAttributes[]
}

function PastEvents({ title, lists }: Props) {
  const slides = useMemo(() => {
    return lists.map(list => <Slide list={list} key={list.eventTitle} />)
  }, [lists])

  return (
    <section className="font-body bg-blue-web-90">
      <div className="container | py-9 md:py-20">
        <h4 className="font-heading | text-3xl lg:text-4xl font-semibold text-white text-center md:text-left | mb-9 md:mb-14">
          {title}
        </h4>
        <CarouselAlt
          sliderClassName="mb-10"
          autoScroll={false}
          navigationType="dot"
          slides={slides}
        />
      </div>
    </section>
  )
}

const Slide = ({ list }: { list: IndividualEventsPageAttributes }) => {
  return (
    <div key={list.eventType}>
      <Link href={list.slug}>
        <div className="snap-center | bg-white border border-gray-40 hover:border-blue-web-50 | transition-colors delay-200 ease-in shadow-md rounded-lg | max-w-[313px] md:max-w-[350px] | relative">
          <Image
            src={list.heroImage.data.attributes.url ?? ''}
            alt={list.heroImage.data.attributes.alternativeText ?? ''}
            width={list.heroImage.data.attributes.width}
            height={list.heroImage.data.attributes.height}
            className="rounded-t-lg"
          />
          <div className="flex flex-col | text-left | p-5">
            {list.tag ? (
              <div className="mb-3">
                <span
                  className="uppercase text-small text-black | border border-black rounded-md | py-1 px-2"
                  dangerouslySetInnerHTML={{
                    __html: list.tag
                  }}
                />
              </div>
            ) : null}
            {list.eventTitle ? (
              <h3
                className="font-heading | text-xl lg:text-2xl text-black hover:text-blue-web-50 font-semibold | line-clamp-2 lg:h-14 | mb-3"
                dangerouslySetInnerHTML={{
                  __html: list.eventTitle
                }}
              />
            ) : (
              <div className="h-16 mb-3"></div>
            )}

            {list.eventDescription ? (
              <div
                className="text-sm text-gray-70 | line-clamp-2 lg:h-9 | mb-3"
                dangerouslySetInnerHTML={{
                  __html: list.eventDescription
                }}
              />
            ) : (
              <div className="h-9 mb-3" />
            )}
            <div className="text-small text-black font-semibold | mb-4">
              <div>{list.eventDate}</div>
              <div>{list.startTime}</div>
            </div>
            <div className="flex justify-center items-center font-medium text-blue-web-50 capitalize | border border-blue-web-50 rounded px-4 py-2">
              watch recordings
              <ArrowRight className="ml-2" />
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default PastEvents
